(function ($) {
  'use strict';

  var $container = $('#arr-telemetry-chart-container-new');
  var $empty = $('#arr-telemetry-chart-empty');
  var $loading = $('#arr-telemetry-chart-loading');
  var $title = $('#arr-telemetry-chart-title');
  var $time = $('#waktu');
  var $periode = $('#periode');
  var chart = null;

  if (!$container.length) {
    return;
  }

  var telemetryChartAjaxGuard =
    typeof createTelemetryChartLoadGuard === 'function'
      ? createTelemetryChartLoadGuard()
      : {
          start: function () {
            return {
              isCurrent: function () {
                return true;
              },
              register: function () {},
              clearIfCurrent: function () {},
            };
          },
        };

  function getSelectedTime() {
    return $time.length && $time.val() ? $time.val() : 'minute';
  }

  function normalizeFilterDate(selectedTime, value) {
    var raw = (value || '').trim();
    var monthNameFormats = ['MMMM YYYY', 'MMM YYYY'];
    var dayNameFormats = ['D MMMM YYYY', 'DD MMMM YYYY', 'D MMM YYYY'];

    if (selectedTime === 'day') {
      if (moment(raw, 'YYYY', true).isValid()) {
        return moment(raw, 'YYYY', true).format('YYYY');
      }

      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY');
      }

      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY');
      }

      var dayParsed = moment(raw, dayNameFormats, 'id', true);
      if (!dayParsed.isValid()) {
        dayParsed = moment(raw, dayNameFormats, true);
      }
      if (dayParsed.isValid()) {
        return dayParsed.format('YYYY');
      }

      var monthParsedForYear = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsedForYear.isValid()) {
        monthParsedForYear = moment(raw, monthNameFormats, true);
      }
      if (monthParsedForYear.isValid()) {
        return monthParsedForYear.format('YYYY');
      }

      return moment().format('YYYY');
    }

    if (selectedTime === 'hour') {
      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
      }

      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM');
      }

      var monthParsed = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsed.isValid()) {
        monthParsed = moment(raw, monthNameFormats, true);
      }
      if (monthParsed.isValid()) {
        return monthParsed.format('YYYY-MM');
      }

      if (moment(raw, 'YYYY', true).isValid()) {
        return moment().year(Number(raw)).format('YYYY-MM');
      }

      return moment().format('YYYY-MM');
    }

    if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
      return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
    }

    var dayParsedMinute = moment(raw, dayNameFormats, 'id', true);
    if (!dayParsedMinute.isValid()) {
      dayParsedMinute = moment(raw, dayNameFormats, true);
    }
    if (dayParsedMinute.isValid()) {
      return dayParsedMinute.format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY-MM', true).isValid()) {
      return moment(raw, 'YYYY-MM', true).startOf('month').format('YYYY-MM-DD');
    }

    var monthParsedMinute = moment(raw, monthNameFormats, 'id', true);
    if (!monthParsedMinute.isValid()) {
      monthParsedMinute = moment(raw, monthNameFormats, true);
    }
    if (monthParsedMinute.isValid()) {
      return monthParsedMinute.startOf('month').format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY', true).isValid()) {
      return moment(raw, 'YYYY', true).startOf('year').format('YYYY-MM-DD');
    }

    return moment().format('YYYY-MM-DD');
  }

  function getFilterDate(selectedTime) {
    var value = $periode.length ? $periode.val() : '';
    return normalizeFilterDate(selectedTime, value);
  }

  function getChartMeta(selectedTime) {
    if (selectedTime === 'minute') {
      return {
        title: 'Grafik Curah Hujan Per 5 Menit',
        tooltipFormat: 'D MMMM YYYY HH:mm',
      };
    }

    if (selectedTime === 'day') {
      return {
        title: 'Grafik Curah Hujan Harian',
        tooltipFormat: 'D MMMM YYYY',
      };
    }

    return {
      title: 'Grafik Curah Hujan Jam-Jaman',
      tooltipFormat: 'D MMMM YYYY HH:mm',
    };
  }

  function capitalizeFirst(text) {
    if (!text) {
      return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function getSubtitleText(selectedTime, filterDate) {
    var now = moment();

    if (selectedTime === 'day') {
      var yearMoment = moment(filterDate, 'YYYY', true).isValid()
        ? moment(filterDate, 'YYYY', true)
        : moment(filterDate, 'YYYY-MM', true).isValid()
          ? moment(filterDate, 'YYYY-MM', true)
          : moment(filterDate, 'YYYY-MM-DD', true).isValid()
            ? moment(filterDate, 'YYYY-MM-DD', true)
            : now.clone();
      var yearStart = yearMoment.clone().startOf('year');
      var yearEnd = yearMoment.isSame(now, 'year')
        ? now.clone().startOf('day')
        : yearMoment.clone().endOf('year');
      return (
        'Periode ' +
        capitalizeFirst(yearStart.locale('id').format('DD MMMM YYYY')) +
        ' sampai ' +
        capitalizeFirst(yearEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    if (selectedTime === 'hour') {
      var monthMoment = moment(filterDate, 'YYYY-MM', true).isValid()
        ? moment(filterDate, 'YYYY-MM', true)
        : moment(filterDate, 'YYYY-MM-DD', true).isValid()
          ? moment(filterDate, 'YYYY-MM-DD', true)
          : now.clone();
      var monthStart = monthMoment.clone().startOf('month');
      var monthEnd = monthMoment.isSame(now, 'month')
        ? now.clone().startOf('day')
        : monthMoment.clone().endOf('month');
      return (
        'Periode ' +
        capitalizeFirst(monthStart.locale('id').format('DD MMMM')) +
        ' sampai ' +
        capitalizeFirst(monthEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    var minuteMoment = moment(filterDate, 'YYYY-MM-DD', true).isValid()
      ? moment(filterDate, 'YYYY-MM-DD', true)
      : now.clone();
    return (
      'Periode ' +
      capitalizeFirst(minuteMoment.locale('id').format('DD MMMM YYYY'))
    );
  }

  function getIntensityThresholds(selectedTime) {
    if (selectedTime === 'day') {
      return [
        { name: 'Hujan Ringan', value: 5, color: '#90caf9' },
        { name: 'Hujan Sedang', value: 20, color: '#fad597' },
        { name: 'Hujan Lebat', value: 50, color: '#f8b584' },
        { name: 'Hujan Sangat Lebat', value: 100, color: '#f89a98' },
      ];
    }

    // hour & minute — nilai per jam / per 5 menit
    return [
      { name: 'Hujan Ringan', value: 0.1, color: '#90caf9' },
      { name: 'Hujan Sedang', value: 5, color: '#fad597' },
      { name: 'Hujan Lebat', value: 10, color: '#f8b584' },
      { name: 'Hujan Sangat Lebat', value: 20, color: '#f89a98' },
    ];
  }

  function getIntensityText(value, selectedTime) {
    var thresholds = getIntensityThresholds(selectedTime);
    var numVal = Number(value);

    if (!Number.isFinite(numVal) || numVal <= 0) {
      return 'Tidak Hujan';
    }

    for (var i = thresholds.length - 1; i >= 0; i--) {
      if (numVal >= thresholds[i].value) {
        return thresholds[i].name;
      }
    }

    return 'Tidak Hujan';
  }

  function buildIntensitySeries(points, selectedTime) {
    if (!points.length) {
      return [];
    }

    var thresholds = getIntensityThresholds(selectedTime);
    var maxObserved = Math.max.apply(
      null,
      points.map(function (p) {
        return p[1];
      }),
    );

    if (!Number.isFinite(maxObserved)) {
      return [];
    }

    var xValues = points.map(function (p) {
      return p[0];
    });

    return thresholds.map(function (threshold) {
      var isActive = maxObserved >= threshold.value;

      return {
        name: threshold.name,
        type: 'line',
        data: xValues.map(function (x) {
          return [x, threshold.value];
        }),
        color: threshold.color,
        lineWidth: 1,
        dashStyle: 'Dash',
        marker: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          allowOverlap: false,
          formatter: function () {
            return this.point.index === 0
              ? '<span style="color:' +
                  this.color +
                  ';font-weight:bold;">' +
                  this.series.name +
                  '</span>'
              : null;
          },
        },
        enableMouseTracking: false,
        showInLegend: true,
        visible: isActive,
      };
    });
  }

  function getZones(selectedTime) {
    if (selectedTime === 'day') {
      return [
        { value: 0, borderColor: '#4b5157', color: '#CCCCCC66' },
        { value: 20, borderColor: '#0581a1', color: '#39A6F599' },
        { value: 50, borderColor: '#a87f05', color: '#F7B84B99' },
        { value: 100, borderColor: '#a34d15', color: '#F2832399' },
        { borderColor: '#b3253a', color: '#EF535099' },
      ];
    }

    // hour & minute — same thresholds
    return [
      { value: 0, borderColor: '#4b5157', color: '#CCCCCC66' },
      { value: 5, borderColor: '#0581a1', color: '#39A6F599' },
      { value: 10, borderColor: '#a87f05', color: '#F7B84B99' },
      { value: 20, borderColor: '#a34d15', color: '#F2832399' },
      { borderColor: '#b3253a', color: '#EF535099' },
    ];
  }

  function pick(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (row[key] != null && row[key] !== '') {
        return row[key];
      }
    }

    return null;
  }

  function getReadingPickKeys(selectedTime) {
    if (selectedTime === 'day') {
      return ['readingDate', 'ReadingDate'];
    }

    if (selectedTime === 'hour') {
      return ['readingHour', 'ReadingHour'];
    }

    return ['readingAt', 'ReadingAt'];
  }

  function getSeriesColor(selectedTime) {
    if (selectedTime === 'minute') {
      return '#22C55E';
    }

    return '#39A6F5';
  }

  function getXAxisLabelFormat(selectedTime) {
    if (selectedTime === 'day') {
      return 'DD MMM YYYY';
    }

    return 'DD MMM YYYY HH:mm';
  }

  /**
   * Batas atas sumbu Y mengikuti puncak data (+ sedikit headroom), dibulatkan
   * ke langkah tick yang enak dibaca — hindari skala 0–100 saat data < 70 mm.
   */
  function computeRainfallYAxisMax(points, selectedTime) {
    var dataMax = 0;
    var i;
    var y;

    for (i = 0; i < points.length; i++) {
      y = points[i][1];
      if (Number.isFinite(y)) {
        dataMax = Math.max(dataMax, y);
      }
    }

    if (dataMax <= 0) {
      if (selectedTime === 'minute') {
        return 1;
      }
      if (selectedTime === 'hour') {
        return 10;
      }
      return 10;
    }

    var cap = dataMax * 1.12 + Math.max(0.5, dataMax * 0.03);
    var step;

    if (cap <= 1) {
      step = 0.1;
    } else if (cap <= 5) {
      step = 0.5;
    } else if (cap <= 20) {
      step = 1;
    } else if (cap <= 60) {
      step = 2;
    } else if (cap <= 150) {
      step = 5;
    } else {
      step = Math.pow(10, Math.floor(Math.log10(cap)));
    }

    return Math.ceil(cap / step) * step;
  }

  function toPoints(rows, selectedTime) {
    var readingKeys = getReadingPickKeys(selectedTime);

    return rows
      .map(function (row) {
        var rawDate = pick(row, readingKeys);
        var rainfallRaw = pick(row, ['rainfall', 'Rainfall']);
        var rainfall = Number(rainfallRaw != null ? rainfallRaw : 0);
        var timestamp = rawDate != null ? moment.utc(rawDate).valueOf() : NaN;
        return [timestamp, Number.isFinite(rainfall) ? rainfall : 0];
      })
      .filter(function (point) {
        return Number.isFinite(point[0]);
      })
      .sort(function (a, b) {
        return a[0] - b[0];
      });
  }

  function showEmpty(message) {
    if (chart) {
      chart.destroy();
      chart = null;
    }

    $container.hide();
    $loading.hide();
    $empty.text(message).show();
  }

  function showLoading() {
    $empty.hide();
    $container.hide();
    $loading.css('display', 'block');
  }

  function hideLoading() {
    $loading.hide();
  }

  function renderChart(points, selectedTime, filterDate) {
    var meta = getChartMeta(selectedTime);
    var zones = selectedTime !== 'minute' ? getZones(selectedTime) : null;
    var intensitySeries =
      selectedTime !== 'minute'
        ? buildIntensitySeries(points, selectedTime)
        : [];
    var subtitleText = getSubtitleText(selectedTime, filterDate);
    var seriesColor = getSeriesColor(selectedTime);
    var xAxisLabelFormat = getXAxisLabelFormat(selectedTime);
    var yAxisMax = computeRainfallYAxisMax(points, selectedTime);

    $title.text(meta.title);
    $empty.hide();
    hideLoading();
    $container.show();

    if (chart) {
      chart.destroy();
      chart = null;
    }

    chart = Highcharts.chart('arr-telemetry-chart-container-new', {
      chart: {
        type: 'column',
        zoomType: 'x', // Memberikan ruang cukup untuk legend + navigator di bawah
      },
      navigator: {
        enabled: true,
        height: 25, // Dikecilkan ukurannya (sebelumnya mungkin 40-50)
        margin: 5, // Mengurangi jarak antar elemen
        xAxis: {
          labels: {
            style: { fontSize: '9px' }, // Font kecil agar proporsional
            dateTimeLabelFormats: {
              hour: '%H:%M', // Tetap format 24 jam
              minute: '%H:%M',
            },
          },
        },
      },
      title: {
        text: meta.title,
      },
      subtitle: {
        text: subtitleText,
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        // Memberikan margin negatif atau mengatur y agar naik ke atas navigator
        floating: false, // Set false agar tidak menutupi chart utama
        itemStyle: { fontSize: '11px' },
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Waktu',
          style: {
            fontSize: '11px', // Opsional: Mengecilkan ukuran judul sumbu juga
          },
        },
        labels: {
          rotation: -25,
          formatter: function () {
            return moment.utc(this.value).locale('id').format(xAxisLabelFormat);
          },
        },
        crosshair: {
          color: 'rgb(241, 245, 249, 0.8)',
          width: 20,
        }
      },
      yAxis: {
        min: 0,
        max: yAxisMax,
        endOnTick: false,
        gridLineWidth: 0,
        title: {
          text: 'Curah Hujan (mm)',
        },
      },
      tooltip: {
        formatter: function () {
          var dateLabel = moment
            .utc(this.x)
            .locale('id')
            .format(meta.tooltipFormat);
          var intensityLine =
            selectedTime !== 'minute'
              ? '<br/>Intensitas: <b>' +
                getIntensityText(this.y, selectedTime) +
                '</b>'
              : '';
          var fy =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber(this.y)
              : String(this.y);
          return (
            '<b>' +
            dateLabel +
            '</b><br/>Curah Hujan: <b>' +
            fy +
            ' mm</b>' +
            intensityLine
          );
        },
        shared: true,
        split: false,
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          pointPadding: 0,
          groupPadding: 0,
          minPointLength: 1,
          stickyTracking: true,
        }
      },
      series: [
        {
          name: 'Curah Hujan',
          type: 'column',
          data: points,
          color: seriesColor,
          zones: zones || undefined,
          zoneAxis: zones ? 'y' : undefined,
        },
      ].concat(intensitySeries),
      credits: {
        enabled: false,
      },
    });
  }

  function loadRealChart() {
    if (typeof Highcharts === 'undefined') {
      showEmpty('Highcharts belum tersedia.');
      return;
    }

    var selectedTime = getSelectedTime();
    var filterDate = getFilterDate(selectedTime);

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    var jqXHR = $.ajax({
      url: '/Station/GetChartDataArr',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
      },
    });
    g.register(jqXHR);

    jqXHR
      .done(function (response) {
        if (!g.isCurrent()) {
          return;
        }
        var rows = response && response.data ? response.data : [];
        var points = toPoints(rows, selectedTime);

        if (!points.length) {
          showEmpty('Data grafik tidak tersedia.');
          return;
        }

        renderChart(points, selectedTime, filterDate);
      })
      .fail(function (_xhr, status) {
        if (status === 'abort') {
          return;
        }
        if (!g.isCurrent()) {
          return;
        }
        showEmpty('Gagal memuat data grafik.');
      })
      .always(function () {
        g.clearIfCurrent();
      });
  }

  function init() {
    if ($time.length) {
      $time.on('change', loadRealChart);
    }

    if ($periode.length) {
      $periode.on('change', loadRealChart);
    }

    $('a[data-bs-toggle="tab"][href="#tab-data-telemetri"]').on(
      'shown.bs.tab',
      function () {
        loadRealChart();
      },
    );

    loadRealChart();
  }

  init();
})(jQuery);
